import { amountToDisplayValue, DateTimeFormat } from '@billy/design-system'
import { ChangeEvent, ReactElement } from 'react'

import { getBankLineDescription } from '@features/bankTransactions/utils/getBankLineDescription'
import { BankLine } from '@modules-deprecated/bankReconciliation/types'
import { prefixAmount } from '@modules-deprecated/bankReconciliation/utils'

import { getCurrentLocale } from '../../../../../../../../utils'
import { ListItem, ListItemProps } from '../ListElements/ListItem/ListItem'

interface TransactionItemProps
  extends Omit<ListItemProps, 'description' | 'displayAmount' | 'date' | 'icon' | 'handleCheckboxChange'> {
  transactionItem: BankLine
  currency?: string
  showSignedAmount?: boolean
  onCheckedChange?: (checked: boolean) => void
}

export const TransactionItem = ({
  transactionItem,
  currency,
  showSignedAmount = false,
  isOutlined = false,
  checked = false,
  onCheckedChange,
  showCheckbox = false,
}: TransactionItemProps): ReactElement => {
  const { description, amount, side, entryDate } = transactionItem

  const locale = getCurrentLocale()
  const formattedDate = DateTimeFormat.getFormattedDate(entryDate, locale)
  const signedAmount = showSignedAmount ? prefixAmount({ side, amount }) : amount
  const displayAmount = `${amountToDisplayValue(signedAmount, false)}${currency ? ` ${currency}` : ''}`

  const handleCheckboxChange = (event: ChangeEvent<HTMLInputElement>) => {
    onCheckedChange?.(event.target.checked)
  }

  return (
    <ListItem
      description={getBankLineDescription(description)}
      displayAmount={displayAmount}
      date={formattedDate}
      icon="arrowRightLeft"
      isOutlined={isOutlined}
      checked={checked}
      handleCheckboxChange={handleCheckboxChange}
      showCheckbox={showCheckbox}
    />
  )
}
